<script>
import Layout from "../../layouts/main";
import axios from "axios";
import ErrorAlert from '../../../components/errorAlert.vue';
import { toast, variants } from "@/helpers/toaster";

export default {
  page: {
    title: "Manuals",
  },
  components: {Layout,ErrorAlert},
  props: {
  },
  data() {
    return {
      title: 'Manuals',
      admin_help_link: '',
      employee_help_link: '',
    }
  },
  async mounted() {
    this.$store.commit('loader/START_LOADING');

    await axios.get('/super-admin/help-document').then(response => {
      this.admin_help_link = response.data.admin_help_link;
      this.employee_help_link = response.data.employee_help_link;
    }).finally(() => this.$store.commit('loader/END_LOADING'));
  },
  methods: {
    async submitForm() {
      this.$store.commit('loader/START_LOADING');

      try {
        await axios.put('/super-admin/help-document', 
          {
            admin_help_link: this.admin_help_link,
            employee_help_link: this.employee_help_link,
          }
        )
        .then(response => {
          this.employees = response.data;
          toast('Uspešno sačuvani linkovi ka uputstvima.', variants.SUCCESS);
        })
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
  }
}
</script>

<template>
  <Layout>
    <error-alert></error-alert>
    <div class="row">
      <div class="col-12 mb-5 pb-4">
        <div class="card">
          <div class="card-body">
            <div class="mt-4">
              <h3 class="mb-4">Uputstva</h3>
              <b-form @submit.prevent="submitForm()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>
                        Link ka uputstvu za firme
                      </label>
                      <b-form-input v-model="admin_help_link"  id="administrator-partner-id-input" type="text"></b-form-input>
                    </div>

                    <div class="form-group">
                      <label>
                        Link ka uputstvu za objekte
                      </label>
                      <b-form-input v-model="employee_help_link"  id="administrator-company-id-input" type="text"></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <b-button type="submit" variant="primary" class="ml-2" >Snimi</b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  .autocomplete {
    width: 100%;
  }

  .limitlabel {
    text-wrap: nowrap;
  }
</style>
